import React, { useState, useRef } from 'react';
import { Obliterate } from 'shared/helpers';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Creators as reduxEtapas } from 'store/ducks/etapas';
import { Creators as reduxRespostas } from 'store/ducks/respostas';

import Styles from './NutritionalEditor.module.scss';

import Frame from './Frame/Frame';

import { useEditableContext } from 'shared/hooks';

export default function NutritionalEditor({
  id,
  etapas,
  produtos,
  tableKey,
  phase,
  renderables,
  setRefresh,
  medida,
  perguntaId,
}) {
  useEditableContext();
  const { NutritionalEditor, Saver } = Styles;
  const dispatch = useDispatch();

  let frameCount = 0;

  const sent = useRef(false);
  const [editorPane, setEditorPane] = useState(0);
  const [medidaForm, setMedidaForm] = useState(medida);
  const [form, setForm] = useState({
    fase_id: phase,
    local_id: Obliterate(etapas.map((x) => [x.ordem, x._id])),
    etapa_id: Obliterate(etapas.map((x) => [x.ordem, x.id])),
    fenologica: Obliterate(etapas.map((x) => [x.ordem, x.fenologica])),
    aplicacao: Obliterate(etapas.map((x) => [x.ordem, x.aplicacao])),
    produtos: Obliterate(
      etapas.map((x) => [
        x.ordem,
        Obliterate(
          x.produtos
            .filter((p) => p.fase_id === phase)
            .map((a, b) => [b + 1, a.id]),
        ),
      ]),
    ),
    quantidade: Obliterate(
      etapas.map((x) => [
        x.ordem,
        Obliterate(
          x.produtos
            .filter((p) => p.fase_id === phase)
            .map((a, b) => [b + 1, a.quantidade]),
        ),
      ]),
    ),
    valor: Obliterate(
      etapas.map((x) => [
        x.ordem,
        Obliterate(
          x.produtos
            .filter((p) => p.fase_id === phase)
            .map((a, b) => [b + 1, a.valor]),
        ),
      ]),
    ),
  });

  const send = () => {
    if (sent.current) return;
    sent.current = true;
    const resultingForm = Object.entries(form).reduce(
      (resultingForm, [formKey, formEtapaMap]) => ({
        ...resultingForm,
        [formKey]:
          typeof formEtapaMap === 'object'
            ? Object.keys(formEtapaMap).reduce(
                (resultingFormEtapa, etapaStep) =>
                  !form.fenologica[etapaStep]
                    ? {
                        ...resultingFormEtapa,
                      }
                    : {
                        ...resultingFormEtapa,
                        [etapaStep]: formEtapaMap[etapaStep],
                      },
                {},
              )
            : formEtapaMap,
      }),
      {},
    );
    dispatch(reduxEtapas.updateEtapas(id, resultingForm, etapas));
    if (medida !== medidaForm && perguntaId) {
      dispatch(
        reduxRespostas.saveRespostas(
          id,
          phase,
          {
            pergunta: {
              [perguntaId]: medidaForm,
            },
          },
          (p) => String(p.pem_id) === String(id),
        ),
      );
    }
    setTimeout(() => {
      setRefresh(true);
    }, 1000);
  };

  const Frames = [];
  for (let i = 1; i <= 12; i++) {
    Frames.push(
      <Frame
        n={i}
        open={editorPane === i}
        setPane={() => setEditorPane(editorPane !== i ? i : 0)}
        phase={phase}
        fenologica={form.fenologica[i]}
        aplicacao={form.aplicacao[i]}
        fprodutos={form.produtos[i]}
        quantidades={form.quantidade[i]}
        etapaid={form.etapa_id[i] || null}
        valores={form.valor[i]}
        produtos={produtos}
        setter={setForm}
        renderables={renderables}
        medida={medidaForm}
        updateMedida={setMedidaForm}
        key={`${tableKey}${++frameCount}`}
      />,
    );
  }

  return (
    <div className={NutritionalEditor}>
      <div>
        {
          'Para preenchimento dos Produtos/quantidades/Preço é obrigatório o preenchimento do campo "Etapa Fenológica"'
        }
      </div>
      <button onClick={send} className={Saver} id='btn_salvar'>
        Salvar
      </button>
      {Frames}
    </div>
  );
}

NutritionalEditor.propTypes = {
  id: PropTypes.number.isRequired,
  etapas: PropTypes.any.isRequired,
  produtos: PropTypes.any.isRequired,
  tableKey: PropTypes.string.isRequired,
  phase: PropTypes.number.isRequired,
  renderables: PropTypes.any.isRequired,
  setRefresh: PropTypes.func.isRequired,
};
